import type { CallerIdMode, CallerOptions } from "@/services/telephonyApi";

// Auswahl der angezeigten Rufnummer im Dialog „Anruf vorbereiten"
// (Kundenfeedback 30.10.2026, I). Die Vorbelegung (Favorit, sonst Vorgabe von
// Unternehmen bzw. Organisation) kommt vom Backend; hier wird sie nur gegen die
// tatsächlich wählbaren Nummern abgesichert.

/** Rollen, die die Organisationsseite öffnen dürfen (router.ts, PageOrganization). */
const CENTRAL_SETTINGS_ROLES = new Set(["Administrator", "Unternehmensleiter", "Standortleiter"]);

function isSelectable(options: CallerOptions, mode: CallerIdMode | null): mode is CallerIdMode {
  return options.options.some((option) => option.mode === mode);
}

/** Vorbelegung des Dialogs; null, solange keine Auswahl geladen ist. */
export function initialCallerMode(options: CallerOptions | null): CallerIdMode | null {
  if (!options) return null;
  return isSelectable(options, options.preselected) ? options.preselected : "kars";
}

/** Wert für den Anruf; undefined heißt: ohne Auswahl, die Vorgabe gilt. */
export function callerModeForCall(
  options: CallerOptions | null,
  selected: CallerIdMode | null,
): CallerIdMode | undefined {
  return options && isSelectable(options, selected) ? selected : undefined;
}

/** Ist die gewählte Nummer bereits der gespeicherte Favorit? */
export function isFavoriteChoice(options: CallerOptions | null, selected: CallerIdMode | null): boolean {
  return !!options && !!selected && options.favorite === selected;
}

export function canOpenCentralSettings(role: string): boolean {
  return CENTRAL_SETTINGS_ROLES.has(role);
}

/** Direktsprung in das Telefon-Panel des Unternehmens. */
export function centralSettingsRoute(idCompany: number | null) {
  return {
    name: "PageOrganization",
    query: {
      bereich: "unternehmen",
      abschnitt: "kommunikation",
      panel: "phone",
      ...(idCompany ? { unternehmen: String(idCompany) } : {}),
      from: "hub",
    },
  };
}
